import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../../AuthContext'
import {
  Title,
  PrimaryOutlineButton,
  Subtitle,
} from '../../Utils/CustomClasses'
import MyFreebirdConditionalLink from '../MyFreebirdConditionalLink'
import styled from 'styled-components'

const MatchingHostsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0 50px 0;

  h1 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    margin: 0 0 5px 0;
  }

  h2 {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 300;
  }

  .image-user {
    margin-right: 2vw;
    position: relative;

    img {
      border-radius: 10px;
      width: 130px;
      height: 160px;
      overflow: hidden;
      object-fit: cover;
      object-position: center;
    }
  }

  .info-user {
    width: -webkit-fill-available;
  }

  .action-user {
    width: -webkit-fill-available;
    text-align: end;
    button {
      min-width: 100px;
    }
  }

  @media screen and (max-width: 799px) {
    flex-direction: column;
    align-items: center;
    margin: 20px 0 65px 0;

    .image-user,
    .info-user,
    .action-user {
      text-align: center !important;
    }

    .image-user {
      width: 100%;
      margin-right: 0%;
      margin-bottom: 2vw;

      img {
        width: 100%;
        height: auto;
      }
    }

    &:last-of-type {
      margin: 20px 0 40px 0;
    }
  }
`

const ImagesWrapper = styled.div`
  position: relative;
`

const CustomPrimaryOutlineButton = styled(PrimaryOutlineButton)`
  padding: 12px 20px;
  border: 1px solid #000;
  border-color: #000;

  color: #000 !important;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
`

const PlacePhotoContainer = styled.div`
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 3px solid #fff;
  border-radius: 50%;
  position: absolute;
  bottom: -9px;
  right: 12px;
  z-index: 100;

  img {
    object-fit: cover;
    min-width: 100%;
    min-height: 100%;
  }

  @media screen and (max-width: 799px) {
    bottom: 22px;
  }
`

const FeaturedHomestayHosts = ({ user, stage1Achieved, messageTrigger }) => {
  const [results, setResults] = useState('')

  useEffect(() => {
    axios
      .get(`/api/VYGVA82re2f8e2/latesthosts`)
      .then((response) => {
        setResults(
          response.data.map((d, index) => {
            return (
              <MatchingHosts
                key={index}
                userId={d.fbc_core_user.id}
                circleId={d.fbc_core_user.circleId}
                memberImageUrl={d.fbc_core_user.profilePhotoL}
                placeId={d.id}
                placeImageUrl={d.placePhotoO}
                name={d.fbc_core_user.forename}
                location={d.fbc_core_user.country.nicename}
                profile={
                  d.fbc_core_user.introduction
                    .replace(/(<([^>]+)>)/gi, '')
                    .split(/\s+/)
                    .slice(0, 20)
                    .join(' ') + '...'
                }
              />
            )
          })
        )
      })
      .catch((err) => {
        console.log('Error getting latest featured homestay hosts: ', err)
      })
  }, [stage1Achieved])

  const MatchingHosts = ({
    userId,
    circleId,
    memberImageUrl,
    placeId,
    placeImageUrl,
    name,
    location,
    profile,
  }) => {
    return (
      <MatchingHostsContainer>
        <ImagesWrapper>
          <div className="image-user">
            <MyFreebirdConditionalLink
              linkUrl={'/place/' + placeId}
              stage1Achieved={stage1Achieved}
              messageTrigger={messageTrigger}
            >
              <img
                src={s3AwsEndpoint + '/' + placeImageUrl}
                onError={(e) => {
                  e.target.onError = null
                  e.target.src = '/images/listing/default-profile.png'
                }}
              />
            </MyFreebirdConditionalLink>
          </div>

          <MyFreebirdConditionalLink
            linkUrl={'/user/' + userId}
            stage1Achieved={stage1Achieved}
            messageTrigger={messageTrigger}
          >
            <PlacePhotoContainer>
              <img
                src={s3AwsEndpoint + '/' + memberImageUrl}
                onError={(e) => {
                  e.target.onError = null
                  e.target.src = '/images/listing/default-profile.png'
                }}
              />
            </PlacePhotoContainer>
          </MyFreebirdConditionalLink>
        </ImagesWrapper>

        <div className="info-user">
          <MyFreebirdConditionalLink
            linkUrl={'/user/' + userId}
            stage1Achieved={stage1Achieved}
            messageTrigger={messageTrigger}
          >
            <Title size="20px" sizemd="20px" sizesm="20x" margin="0 0 10px 0">
              {name}
            </Title>
          </MyFreebirdConditionalLink>
          <Subtitle size="20px" sizemd="20px" sizesm="20x" margin="0 0 10px 0">
            {location}
          </Subtitle>
          <Subtitle
            size="20px"
            sizemd="20px"
            sizesm="20x"
            margin="0 0 10px 0"
            marginsm="20px 20px"
          >
            {profile}
          </Subtitle>
        </div>
        <div className="action-user">
          <MyFreebirdConditionalLink
            linkUrl={'/user/' + userId}
            stage1Achieved={stage1Achieved}
            messageTrigger={messageTrigger}
          >
            <CustomPrimaryOutlineButton>{'View'}</CustomPrimaryOutlineButton>
          </MyFreebirdConditionalLink>
        </div>
      </MatchingHostsContainer>
    )
  }

  if (!results) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ margin: '100px auto 100px', opacity: '0.3' }}
          role="status"
        ></div>
      </div>
    )
  }
  return results
}

export default withRouter(withAuth(FeaturedHomestayHosts))
